<template>
  <div class=sp_header>
    <i class="el-icon-back"
       title="Close"
       v-if="showClose"
       @click="handleClose"></i>
    <h2>{{title}}</h2>

  </div>
</template>

<script>
export default {
  name: 'headeTitle',
  props: {
    title: {
      type: String,
      required: true,
      default: '',
    },
    showClose: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data () {
    return {

    }
  },

  methods: {
    handleClose () {
      this.$emit('closePage', false);
    }
  }
}
</script>

<style scoped lang="scss">
.sp_header {
  width: 100%;
  display: flex;
  background-color: #f0f3f7;
  justify-content: flex-start;
  align-items: center;
  height: 40px;
  box-sizing: border-box;
  padding-bottom: 10px;
  font-size: 20px;
  font-weight: 500;
  color: #13161a;
  border-bottom: none;
  .el-icon-back {
    color: #2684ff;
  }
  h2 {
    font-size: 20px;
    color: #13161a;
    line-height: 37px;
    font-weight: 500;
  }
  i {
    font-size: 24px;
    cursor: pointer;
    margin-right: 18px;
  }
}
</style>